import { render, staticRenderFns } from "./area-raw-material-redirector.vue?vue&type=template&id=1f062096&"
import script from "./area-raw-material-redirector.vue?vue&type=script&lang=js&"
export * from "./area-raw-material-redirector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f062096')) {
      api.createRecord('1f062096', component.options)
    } else {
      api.reload('1f062096', component.options)
    }
    module.hot.accept("./area-raw-material-redirector.vue?vue&type=template&id=1f062096&", function () {
      api.rerender('1f062096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouses/area-raw-material-redirector.vue"
export default component.exports